import { StudioJumpSystem } from '../enums';

// Studio Overall预览页 tabs页面key 配置，可用于获取页面打点配置信息
const STUDIO_OVERALL_PAGE_LOG_KEY_MAP: any = {
  /*** Studio Overall预览页 ***/
  // overview: 'STUDIO_OVERALL_OVERVIEW', // overview页签打点规则在对应页面具体分页签打点
  calendar: 'STUDIO_OVERALL_CALENDAR',
  // projects: 'STUDIO_OVERALL_PROJECTS', // projects页签打点规则在对应页面具体分页签打点
  // finance: 'STUDIO_OVERALL_FINANCE', // finance页签打点规则在对应页面具体分页签打点
  people: 'STUDIO_OVERALL_PEOPLE',
  // management: 'STUDIO_OVERALL_MANAGEMENT', // management页签打点规则在对应页面具体分页签打点
  /*** Studio Overall预览页 ***/
};

const STUDIO_MAP = [
  'total',
  'amplifier',
  'astra',
  'nexus',
  'saturn',
  'solar',
  'others',
];

export const STUDIO_OVERALL_PAGE_CLASSNAME = 'dbg-studio-overall';

export const STUDIO_OVERALL_PAGE_BODY_CLASSNAME = 'dbg-studio-overall-body';

// Studio/Portfolio Overview页面 Management页签 滚动动态增、删数据 需要用这个css选择器 查找滚动那个元素，修改这里记得测下那个页面 数据展示是否正常
export const STUDIO_OVERALL_SCROLLABLE_EL_SELECTOR = `.${STUDIO_OVERALL_PAGE_CLASSNAME} .${STUDIO_OVERALL_PAGE_BODY_CLASSNAME}`;

// 点击Studio名，支持跳转的系统
export const STUDIO_JUMP_SYSTEMS: IStudioJumpSystem[] = Object.values(StudioJumpSystem);

export {
  STUDIO_OVERALL_PAGE_LOG_KEY_MAP,
  STUDIO_MAP,
};
